var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0771 0.923077C11.0771 0.413276 11.4904 0 12.0002 0C18.6216 0 24.0003 5.36645 24.0003 12.0001V23.0769C24.0003 23.5867 23.587 24 23.0772 24C16.4558 24 11.0771 18.6337 11.0771 12.0001V0.923077ZM12.9233 1.88757V12.0001C12.9233 17.3012 16.9828 21.6462 22.1541 22.1124V12.0001C22.1541 6.69894 18.0946 2.3538 12.9233 1.88757Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.0012C0 11.4914 0.413276 11.0781 0.923077 11.0781H12C12.5098 11.0781 12.9231 11.4914 12.9231 12.0012V23.0781C12.9231 23.5879 12.5098 24.0011 12 24.0011C5.37862 24.0011 0 18.6348 0 12.0012ZM1.88752 12.9243C2.32658 17.7991 6.20919 21.6747 11.0769 22.1136V12.9243H1.88752Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.923077C0 0.413276 0.413276 0 0.923077 0C7.54447 0 12.9231 5.36646 12.9231 12.0001C12.9231 12.5099 12.5098 12.9231 12 12.9231H0.923077C0.413276 12.9231 0 12.5099 0 12.0001V0.923077ZM1.84615 1.88757V11.077H11.0356C10.5965 6.20217 6.71388 2.32643 1.84615 1.88757Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.572b23c6d0496ad67229fac045bb505c.svg";
export { ForwardRef as ReactComponent };